import { create } from 'zustand';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/india`;

export const useInsiderScreenerStore = create((set, get) => ({
  items: [],
  total: 0,
  page: 1,
  pageSize: 50,
  categories: [],
  loading: false,
  error: null,
  filters: { category: '', dateFrom: '', dateTo: '', search: '' },

  setFilters: (f) => set({ filters: { ...get().filters, ...f }, page: 1 }),

  fetch: async (pg) => {
    const { filters, pageSize } = get();
    const p = pg || get().page;
    set({ loading: true, error: null, page: p });
    try {
      const params = new URLSearchParams({ page: p, page_size: pageSize });
      if (filters.category) params.set('category', filters.category);
      if (filters.dateFrom) params.set('date_from', filters.dateFrom);
      if (filters.dateTo) params.set('date_to', filters.dateTo);
      if (filters.search) params.set('search', filters.search);
      const res = await fetch(`${API}/insiders?${params}`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      set({
        items: data.items || [],
        total: data.total || 0,
        categories: data.categories || get().categories,
        loading: false,
      });
    } catch (err) {
      set({ loading: false, error: err.message });
    }
  },
}));
